import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/v1`;

export const http = axios.create({ baseURL: API, withCredentials: true });

export function sessionId() {
  let s = localStorage.getItem("blc_sid");
  if (!s) {
    s = "s-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
    localStorage.setItem("blc_sid", s);
  }
  return s;
}

export function track(event, props = {}) {
  try {
    http.post("/events", [{ event, session_id: sessionId(), ...props }]).catch(() => {});
  } catch (e) {}
}

export function getUTM() {
  const p = new URLSearchParams(window.location.search);
  const utm = {};
  ["utm_source", "utm_medium", "utm_campaign"].forEach((k) => {
    if (p.get(k)) utm[k] = p.get(k);
  });
  return utm;
}

// open the enquiry dialog with a prefill, from anywhere on the page
export function openEnquiry(prefill = {}) {
  window.dispatchEvent(new CustomEvent("blc:enquiry", { detail: prefill }));
}

export function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export async function sha256(text) {
  const buf = await crypto.subtle.digest("SHA-256", new TextEncoder().encode(text));
  return Array.from(new Uint8Array(buf)).map((b) => b.toString(16).padStart(2, "0")).join("");
}

export function inr(n) {
  return Number(n || 0).toLocaleString("en-IN");
}

export function errText(detail) {
  if (!detail) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(detail);
}
